"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupClientBattleListeners = void 0;
const models_1 = require("@creature-chess/models");
const commands_1 = require("~/store/battle/commands");
const events_1 = require("~/store/battle/events");
const battle_1 = require("@creature-chess/battle");
const models_2 = require("@creature-chess/models");
const setupClientBattleListeners = (startListening) => {
    startListening({
        actionCreator: commands_1.pauseBattleCommand,
        effect: (_action, api) => {
            var _a;
            (_a = api.extra.sessionHolder.peek()) === null || _a === void 0 ? void 0 : _a.battle.pause();
        },
    });
    startListening({
        actionCreator: commands_1.resumeBattleCommand,
        effect: (_action, api) => {
            var _a;
            (_a = api.extra.sessionHolder.peek()) === null || _a === void 0 ? void 0 : _a.battle.resume();
        },
    });
    startListening({
        actionCreator: commands_1.startBattleCommand,
        effect: (action, api) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            api.cancelActiveListeners();
            const session = api.extra.sessionHolder.get();
            const { turn } = yield session.battle.start((_a = action.payload.turn) !== null && _a !== void 0 ? _a : 0);
            // A newer startBattleCommand cancelled this listener instance while we
            // were awaiting the runner; the superseding instance owns the dispatch.
            if (api.signal.aborted) {
                return;
            }
            api.dispatch((0, events_1.battleFinishEvent)({ turn }));
        }),
    });
    startListening({
        actionCreator: models_1.GameEvents.gamePhaseStartedEvent,
        effect: ({ payload: { phase } }, api) => {
            api.cancelActiveListeners();
            const { battle, pieceRegistry } = api.extra.sessionHolder.get();
            if (phase === models_2.GamePhase.PLAYING) {
                (0, battle_1.seedCombatStore)(battle.combatStore, battle.board, pieceRegistry);
                api.dispatch((0, commands_1.startBattleCommand)({}));
            }
            if (phase === models_2.GamePhase.PREPARING) {
                battle.board.clear();
                battle.combatStore.clear();
            }
        },
    });
};
exports.setupClientBattleListeners = setupClientBattleListeners;
